import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import EditSchema from './EditSchema';
import View from './View';

const toPath = (id) => {
  if (!id || typeof id !== 'string') return '/';

  try {
    const base =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost:3000';

    return new URL(id, base).pathname || '/';
  } catch {
    return id.startsWith('/') ? id : '/';
  }
};

const ContactEdit = (props) => {
  const { selected, navRoot, data } = props;
  const navRootPath = toPath(navRoot?.['@id']);

  return (
    <>
      <div className="contact-block contact-block--editpreview">
        <View data={data} content={null} />
      </div>

      <SidebarPortal selected={selected}>
        <EditSchema {...props} navRootPath={navRootPath} />
      </SidebarPortal>
    </>
  );
};

export default ContactEdit;
